/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"

/**
 *
 * @param {string} metaData
 * @returns
 */

export function loadRecordsMetaData(metaData, method,payload) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`,payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`,payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

export async function loadPostDetailsApi(searchFilter) {
 
  if (searchFilter) {
    return await api
      .post(`/get_qutation_delivareble_post`, searchFilter)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/get_qutation_delivareble_post`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

export  function addCrmAPI(crm_details) {
  return  api
    .post(`/add_assign_crm_employee_production_quotation_deliverable`, crm_details)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export  function addProductAPI(product_details) {
  return api
    .post(`/add_reassign_production_quotation_deliverable`, product_details)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export  function addTeamAPI(team_details) {
  return  api
    .post(`/add_reassign_employee_production_quotation_deliverable`, team_details)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export  function addMultipleTeamAPI(teamDetails) {
  return  api
    .post(`/add_reassign_employee_production_quotation_deliverable`, teamDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export  function addMultipleProductAPI(productDetails) {
  return api
    .post(`/add_reassign_production_quotation_deliverable`, productDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export  function updateProcessAPI(submitStatus) {
  return  api
    .post(`/update_processStatus_history`, submitStatus)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}


export async function loadProductionAssignHistoryApi(historyPayload) {
  return api
    .post(`/production_assign_history`,historyPayload)
    .catch((error) => Promise.reject(error))
}
export async function loadProductApi(historyPayload) {
  return api
    .post(`/get_all_deliverable_product_category`,historyPayload)
    .catch((error) => Promise.reject(error))
}
export  function addTatAPI(tat_details) {
  return  api
    .post(`/crm_deliverable_updateAPI`, tat_details)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

export  function assignPrintPlAPI(print_details) {
  return  api
    .post(`/add_reasign_print_pl`, print_details)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
const remotes = {
  loadPostDetailsApi,
  loadRecordsMetaData,
  addCrmAPI,
  addProductAPI,
  addTeamAPI,
  addMultipleTeamAPI,
  addMultipleProductAPI,
  updateProcessAPI,
  loadProductionAssignHistoryApi,
  addTatAPI,
  assignPrintPlAPI,
  loadProductApi
}

export default remotes
